import { forwardRef, useImperativeHandle } from "react";
import LazyLoadComponent, { forceCheck } from "react-lazyload";

export const LazyLoad = forwardRef(function LazyLoadWithRef(
  { children, height = 300 },
  ref
) {
  useImperativeHandle(ref, () => ({
    forceCheck,
  }));

  return (
    <LazyLoadComponent height={height} offset={600} unmountIfInvisible={true}>
      {children}
    </LazyLoadComponent>
  );
});
